import MuiBackdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import { styled } from '@mui/system'

const Backdrop = styled(MuiBackdrop)(({ theme }) => ({
  // TODO: theme.zIndex is unknown?
  zIndex: (theme.zIndex as any).drawer + 1,
  backgroundColor: 'rgb(255, 255, 255)',
}))

const AppLoading = () => {
  return (
    <Backdrop open transitionDuration={{ appear: 0 }}>
      <CircularProgress color="primary" />
    </Backdrop>
  )
}

export default AppLoading
